import { BeckyRequestPayload } from '../types/becky'
import { PageJson } from '@wix/thunderbolt-becky-types'
import getPagesJson from './getPagesJson'

const getPayloadWithErrorPage = (payload: BeckyRequestPayload): BeckyRequestPayload => {
	const pageJson = getPagesJson(payload.errorPageId!, payload.isResponsive === 'true')

	if (!pageJson) {
		return payload
	}

	return {
		...payload,
		pages: {
			...payload.pages,
			[payload.errorPageId!]: new Promise((resolve) => resolve(pageJson)) as Promise<PageJson>,
		},
	}
}

export default getPayloadWithErrorPage
